import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import _ from 'lodash';

import Button from 'jbc-front/components/Button';
import { FormSubmitBtn } from 'src/buttons';
import CommonModal from 'jbc-front/components/CommonModal';
import { IMPORT_FROM_ROUMU } from 'src/constants/FormNames';
import { setGlobalErrors } from 'src/reducers/global';

const ImportForm = ({ handleSubmit, submitting, submit, cancelBtnClick, header }) => (
  <React.Fragment>
    <CommonModal.Header hideModal={cancelBtnClick}>{header}</CommonModal.Header>
    <CommonModal.Body>
      <form onSubmit={handleSubmit}>
        <div>連携項目がすべて上書きされます</div>
      </form>
    </CommonModal.Body>
    <CommonModal.Footer>
      <Button onClick={cancelBtnClick} className="u-mr20">
        キャンセル
      </Button>
      <FormSubmitBtn text="取得" {...{ submitting, submit }} />
    </CommonModal.Footer>
  </React.Fragment>
);

let ImportContainer = reduxForm({
  form: IMPORT_FROM_ROUMU
})(ImportForm);

ImportContainer = connect(undefined, (dispatch, ownProps) => ({
  onSubmit: async () => {
    try {
      await ownProps.onSubmit();
      window.location.reload();
    } catch (err) {
      const msg = _.get(err, 'response.data.errors.messages[0]', '同期に失敗しました');
      dispatch(setGlobalErrors(msg));
    }
  }
}))(ImportContainer);

const ImportFromRoumuModal = ({ isOpen, hideModal, onSubmit }) => {
  const header = 'ジョブカン労務管理から事業所情報を取得';

  return (
    <CommonModal ariaHideApp={false} {...{ isOpen, hideModal, onSubmit }}>
      <ImportContainer header={header} cancelBtnClick={hideModal} onSubmit={onSubmit} />
    </CommonModal>
  );
};

export default ImportFromRoumuModal;
